import React, { useState } from 'react';
import { SheetMusicBrowseCommon } from './../browse/SheetMusicBrowseCommon';
import { Header, Divider, Icon } from 'semantic-ui-react'

export function OrganisationSheetMusic(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='song' />
							Sheet Music
						</Header>
					</Divider>
					<SheetMusicBrowseCommon slim={true} organisation={props.organisation}
						urlParams={false} relatedRendered={(val) => setChildRendering(val)}/>
				</>
			}
		</>
	);
}